// @flow

import * as React from "react";
import { NavLink, withRouter, Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import { Site, RouterContextProvider, Nav, Container } from "tabler-react";
import authActions from "../../redux/auth/action";
import $ from "jquery";
// import type { NotificationProps } from "tabler-react";
import ReactHtmlParser from "react-html-parser";

import { changeLanguage } from "../../language/index";
import SiteWrapperSuperadminReact from "../SiteWrapper.superadmin.react";

class SiteWrapperHospitalSuperAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      siteLanguage: "",
      showLang: "ENG",
      user: this.props.user,
    };
    // this.props.setLang({"siteLanguage": 'en'})
  }

  getMenu() {
    let navBarItems;
    navBarItems = [
      {
        value: "Hospital",
        icon: "minus-square",
        subItems: [
          {
            value: changeLanguage(this.props.siteLanguage, "view_hospital"),
            to: "/admin/hospitaltabs/hospital/1",
            LinkComponent: withRouter(NavLink),
          },
          {
            value: changeLanguage(this.props.siteLanguage, "add_hospital"),
            to: "/admin/hospitaltabs/hospital/add",
            LinkComponent: withRouter(NavLink),
          },
        ],
      },
      {
        value: "Appointment Mode",
        icon: "file",
        subItems: [
          {
            value: changeLanguage(
              this.props.siteLanguage,
              "view_appointment_mode",
            ),
            to: "/admin/hospitaltabs/appointmentmode/1",
            LinkComponent: withRouter(NavLink),
          },
          {
            value: changeLanguage(
              this.props.siteLanguage,
              "add_appointment_mode",
            ),
            to: "/admin/hospitaltabs/appointmentmode/add",
            LinkComponent: withRouter(NavLink),
          },
        ],
      },
      {
        value: "Specialization",
        icon: "star",
        subItems: [
          {
            value: changeLanguage(
              this.props.siteLanguage,
              "view_specialization",
            ),
            to: "/admin/hospitaltabs/specialization/1",
            LinkComponent: withRouter(NavLink),
          },
          {
            value: changeLanguage(
              this.props.siteLanguage,
              "add_specialization",
            ),
            to: "/admin/hospitaltabs/specialization/add",
            LinkComponent: withRouter(NavLink),
          },
        ],
      },
      {
        value: "Doctor",
        icon: "activity",
        subItems: [
          {
            value: changeLanguage(this.props.siteLanguage, "view_doctor"),
            to: "/admin/hospitaltabs/doctor/1",
            LinkComponent: withRouter(NavLink),
          },
          {
            value: changeLanguage(this.props.siteLanguage, "add_doctor"),
            to: "/admin/hospitaltabs/doctor/add",
            LinkComponent: withRouter(NavLink),
          },
        ],
      },
    ];
    return navBarItems;
  }
  componentDidMount() {
    this.menuSelection();
    //const { user } = this.props;
    // if (user.role === "client") {
    //   this.props.history.push('/client/dashboard');
    // }
    // this.props.logOut();
    //this.props.history.push('/');
  }

  componentDidUpdate() {
    this.menuSelection();
  }

  menuSelection() {
    var url = window.location.pathname;
    let splitUrl = url.split("/");

    if (
      splitUrl.length &&
      splitUrl[2] !== undefined &&
      splitUrl[2] === "hospitaltabs"
    ) {
      if (splitUrl[3] !== undefined) {
        $(".nav-link").each(function (index, ele) {
          if ($(ele).text() == " Hospital" && splitUrl[3] == "hospital") {
            $(ele).addClass("active");
          } else if (
            $(ele).text() == " Appointment Mode" &&
            splitUrl[3] == "appointmentmode"
          ) {
            $(ele).addClass("active");
          } else if (
            $(ele).text() == " Specialization" &&
            splitUrl[3] == "specialization"
          ) {
            $(ele).addClass("active");
          } else if ($(ele).text() == " Doctor" && splitUrl[3] == "doctor") {
            $(ele).addClass("active");
          }
        });
      }
    }
  }

  render() {
    return (
      <SiteWrapperSuperadminReact>
        <div className="container" style={{ backgroundColor: "white" }}>
          <Nav itemsObjects={this.getMenu()} />
          {this.props.children}
        </div>
      </SiteWrapperSuperadminReact>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    siteLanguage: state.auth.siteLanguage,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    logOut: () => {
      dispatch(authActions.authLogout());
    },
    setLang: (payload) => {
      dispatch(authActions.setLang(payload));
    },
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SiteWrapperHospitalSuperAdmin),
);
